import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Auth0Error } from 'auth0-js';

import { Auth0SignupErrorCodes } from '@arrived/models';

/**
 * Returns helper text to display on the e-mail input for signing up based on a provided Auth0Error. Returns undefined
 * if the auth0Error doesn't have an error code pertaining to the user credentials or is undefined.
 *
 * @param auth0Error the auth0Error from a signup request to display feedback on.
 */
export function useEmailHelperText(auth0Error?: Auth0Error) {
  return useMemo(() => {
    switch (auth0Error?.code) {
      case Auth0SignupErrorCodes.USER_EXISTS:
      case Auth0SignupErrorCodes.USERNAME_EXISTS:
      case Auth0SignupErrorCodes.INVALID_SIGNUP:
        return (
          <FormattedMessage id="invalid-signup" defaultMessage="Invalid signup, please try different credentials." />
        );
    }
    return;
  }, [auth0Error?.code]);
}
